import { render } from "./MindMap.vue?vue&type=template&id=23ccb6da&scoped=true"
import script from "./MindMap.vue?vue&type=script&lang=js"
export * from "./MindMap.vue?vue&type=script&lang=js"

import "./MindMap.vue?vue&type=style&index=0&id=23ccb6da&lang=less"
import "./MindMap.vue?vue&type=style&index=1&id=23ccb6da&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ccb6da"]])

export default __exports__